import log from "loglevel"
import indicadores from "./Indicadores"

class Utils {
  /**
   * Limpia un string de los puntos que provienen del código en R
   * que genera el json de datos de KPIs
   * @param {string} q
   */
  static cleanQuestion = function (q) {
    return q
      .replace(/\.\./g, "##")
      .replace(/\./g, " ")
      .replace(/##/g, ". ")
      .replace("X", "")
      .trim()
  }

  /**
   * Función que calcula los valores de un indicador específico para un cohorte
   * en particular
   * @param {string} _indicador
   * @param {object} _cohorte
   */
  static obtieneIndicadorCohorte = function (_indicador, _cohorte) {
    let indicador = indicadores[_indicador]
    let value = indicador.value(_cohorte)
    let sample = indicador.sample(_cohorte)

    return {
      value: value,
      display: indicador.display(value),
      alert: indicador.alert(value),
      title: indicador.title,
      question: indicador.question,
      sampleSize: sample,
    }
  }
  static calculaHijosCohorte = function (cohorte_padre, usuario) {
    //Si ya existe hijos_indicadores, quiere decir que ya paso por este proceso.
    if (cohorte_padre && cohorte_padre.hijos_indicadores) {
      return cohorte_padre
    } else {
      //Si no existe  hijos_indicadores, lo creamos.
      cohorte_padre.hijos_indicadores = []
    }
    //Buscamos por todos los cohortes que
    Object.values(usuario.cohortes).forEach((_cohorte) => {
      if (
        _cohorte.cohorte_padre_indicadores !== undefined &&
        _cohorte.cohorte_padre_indicadores !== null &&
        _cohorte.cohorte_padre_indicadores === cohorte_padre.id
      ) {
        //Por ahora solo nos importa saber quienes son los hijos, no nos interesa saber las encuestas.
        cohorte_padre.hijos_indicadores[_cohorte.id] = _cohorte
      }
    })

    //Se ejecuta solo cuando exista al menos un hijo.
    if (cohorte_padre.hijos_indicadores.length > 0) {
      //Una vez encontramos todos los hijos procesamos la nueva data.
      let encuestas_type = [
        "parsed_encuesta_general_satisfaccion",
        "parsed_encuesta_salida_programa",
      ]
      encuestas_type.forEach((encuesta) => {
        //Mini hack para EGS y ESP
        let acronimo = ""
        /*if (encuesta === "parsed_encuesta_general_satisfaccion") {
          acronimo = "EGS"
        } else if (encuesta === "parsed_encuesta_salida_programa") {
          acronimo = "ESP"
        } else if (encuesta === "parsed_encuesta_inicio") {
          acronimo = "EIP"
        }*/
        let respuestas = acronimo + "respuestas"
        let matriculados = acronimo + "matriculados"
        let preguntas = acronimo + "preguntas"
        let padre_encuesta = cohorte_padre[encuesta]

        //Debe existir la encuesta parseada.
        if (padre_encuesta && typeof padre_encuesta === "object") {
          cohorte_padre.hijos_indicadores.forEach((hijo) => {
            //El hijo debe tener la encuesta parseada, de lo contrario, no es posible procesarlo.
            if (hijo[encuesta]) {
              let hijo_encuesta = hijo[encuesta]
              //información por pregunta.
              let _preguntasArray = Object.entries(padre_encuesta[preguntas])
              let _preguntas_hijoArray = Object.entries(
                hijo_encuesta[preguntas]
              )
              //El archivo se formatea de esta manera
              //pregunta[0] => pregunta correspondiente (O [key])
              //pregunta[1] => informacion en formato json (objeto) de la pregunta
              //Pasaremos por cada pregunta del cohorte padre y buscaremos solo
              //preguntas que sean identicas en los hijos.
              _preguntasArray.forEach((pregunta) => {
                _preguntas_hijoArray.forEach((preguntaHijo) => {
                  //Si encontramos una pregunta igual a la del hijo
                  if (pregunta[0] === preguntaHijo[0]) {
                    //Si la pregunta es de texto, se une la información.
                    if (pregunta[1].tipo === "texto") {
                      let respuestasHijo =
                        hijo_encuesta[preguntas][preguntaHijo[0]].respuestas ||
                        []
                      let respuestasPadre =
                        padre_encuesta[preguntas][pregunta[0]].respuestas || []
                      if (Array.isArray(respuestasPadre)) {
                        if (!Array.isArray(respuestasHijo)) {
                          respuestasPadre.push(respuestasHijo)
                          //caso donde no hay respuestas
                        } else {
                          respuestasPadre.concat(respuestasHijo)
                        }
                      } else {
                        log.debug("Respuestas padre no es arreglo!")
                        log.debug(cohorte_padre)
                      }
                    }

                    if (pregunta[1].tipo === "numerica") {
                      //des-calculamos el promedio
                      padre_encuesta[preguntas][pregunta[0]].avg =
                        padre_encuesta[preguntas][pregunta[0]].avg *
                        padre_encuesta[preguntas][pregunta[0]].respuestas

                      //Promedio
                      padre_encuesta[preguntas][pregunta[0]].avg +=
                        hijo_encuesta[preguntas][preguntaHijo[0]].avg *
                        hijo_encuesta[preguntas][preguntaHijo[0]].respuestas

                      //Detractores
                      padre_encuesta[preguntas][pregunta[0]].detractores +=
                        hijo_encuesta[preguntas][preguntaHijo[0]].detractores
                      //Promotores
                      padre_encuesta[preguntas][pregunta[0]].promotores +=
                        hijo_encuesta[preguntas][preguntaHijo[0]].promotores
                      //Respuestas

                      padre_encuesta[preguntas][pregunta[0]].respuestas +=
                        hijo_encuesta[preguntas][preguntaHijo[0]].respuestas
                      if (
                        padre_encuesta[preguntas][pregunta[0]].respuestas === 0
                      ) {
                        throw new Error(
                          "Error al obtener el total de respuestas. (Total respuestas = 0)"
                        )
                      }

                      //max
                      if (
                        padre_encuesta[preguntas][pregunta[0]].max <
                        hijo_encuesta[preguntas][preguntaHijo[0]].max
                      ) {
                        padre_encuesta[preguntas][pregunta[0]].max =
                          hijo_encuesta[preguntas][preguntaHijo[0]].max
                      }
                      //min
                      if (
                        padre_encuesta[preguntas][pregunta[0]].min >
                        hijo_encuesta[preguntas][preguntaHijo[0]].min
                      ) {
                        padre_encuesta[preguntas][pregunta[0]].min =
                          hijo_encuesta[preguntas][preguntaHijo[0]].min
                      }

                      //Post procesamiento.
                      //re-calculamos el promedio final.
                      padre_encuesta[preguntas][pregunta[0]].avg =
                        padre_encuesta[preguntas][pregunta[0]].avg /
                        padre_encuesta[preguntas][pregunta[0]].respuestas
                      //Calculamos el nuevo ISNPS
                      padre_encuesta[preguntas][pregunta[0]]["isn.nps"] =
                        (padre_encuesta[preguntas][pregunta[0]].promotores -
                          padre_encuesta[preguntas][pregunta[0]].detractores) /
                        padre_encuesta[preguntas][pregunta[0]].respuestas
                    }
                  }
                })
              })
              //Luego de calcular todo, unimos la información general.
              //sumamos respuestas totales.
              padre_encuesta[respuestas] += hijo_encuesta[respuestas]
              //Sumamos Matriculados totales
              padre_encuesta[matriculados] += hijo_encuesta[matriculados]
            } else {
              console.warn(
                hijo.id +
                  " No posee la encuesta " +
                  encuesta +
                  " Pero su padre : " +
                  cohorte_padre.id +
                  " si"
              )
            }
          })
        }
      })
    }
    return cohorte_padre
  }

  static calculaIndicadoresCohortes = function (_cohorte) {
    // Inicializamos objeto KPIs para el cohorte
    _cohorte.kpis = {}
    // Alertas de cohorte
    _cohorte.kpi_alert = []
    // Iteramos por cada indicador para ir calculándolos y guarando en el cohorte
    // _cohorte = Utils.calculaHijosCohorte(_cohorte, usuario)
    Object.keys(indicadores).forEach((keyindicador) => {
      // Obtiene los valores del indicador para el cohorte
      let _indicadorCohorte = undefined
      try {
        _indicadorCohorte = Utils.obtieneIndicadorCohorte(
          keyindicador,
          _cohorte
        )
      } catch (e) {
        _indicadorCohorte = e.message
      }

      // Guardamos los valores en el atributo kpis
      _cohorte.kpis[keyindicador] = _indicadorCohorte
      if (_indicadorCohorte.alert) {
        _cohorte.kpi_alert.push(keyindicador)
      }
    })
    return _cohorte
  }
  static promedioIndicadorEncuesta = function (_array, _indicador) {
    var _value = 0
    var _contador = 0
    var _muestras = 0
    var _display
    var _conformes = 0

    if (_indicador === undefined || _array === undefined) {
      console.log("Por lo menos uno de los factores está indefinido")
      return undefined
    }

    Object.keys(_array).forEach((_posicion) => {
      if (
        _array[_posicion]["kpis"] &&
        Utils.existeValor(_array[_posicion]["kpis"][_indicador]) === 0
      ) {
        console.log(
          "No existe el atributo para el indicador de la encuesta o bien su nombre ha cambiado"
        )
        console.log(_array[_posicion]["kpis"])
        return undefined
      }
      if (
        _array[_posicion]["kpis"] &&
        Utils.existeValor(_array[_posicion]["kpis"][_indicador]["value"])
      ) {
        _value =
          _value +
          _array[_posicion]["kpis"][_indicador]["value"] *
            _array[_posicion]["kpis"][_indicador]["sampleSize"]
        _conformes += Utils.conformesSimple(
          _array[_posicion]["kpis"][_indicador]["value"]
        )
        _contador += 1
        _muestras += _array[_posicion]["kpis"][_indicador]["sampleSize"]
      }
    })

    /** Se saca la diferencia y se redondea a la unidad */
    if (_contador === 0) {
      _value = undefined
      _display = _value
      _conformes = _value
    } else {
      _value = _value / _muestras
      _display = Number(_value).toFixed(1)
      _conformes = Number((100 * _conformes) / _contador).toFixed(0) + "%"
    }

    return {
      value: _value,
      display: _display,
      conformes: _conformes,
      respuestas: _muestras,
      largo: _contador,
    }
  }
  /* Funciones utilizadas para indicadores */
  static existeValor = function (_value) {
    /** Check for array */
    if (Array.isArray(_value)) {
      if (_value !== []) {
        return 1
      } else {
        return 0
      }
    }

    /** Check for object */
    if (typeof _value === "object") {
      if (_value !== {} && _value !== null) {
        return 1
      } else {
        return 0
      }
    }

    /** Check for constant */
    if (
      _value === undefined ||
      _value === null ||
      _value === "null" ||
      _value === "NULL" ||
      _value === ""
    ) {
      return 0
    } else if (isNaN(_value)) {
      if (typeof _value == "string") {
        return 1
      } else {
        return 0
      }
    } else {
      return 1
    }
  }

  static faltantesBasico = function (_value) {
    _value = 1 - Utils.existeValor(_value)
    return _value
  }

  static porcentajeBasico = function (_value) {
    _value = Utils.existeValor(_value) * 100
    _value = _value + "%"
    return _value
  }

  static existentesIntermedio = function (_array, _encuesta) {
    var _value = 0
    Object.keys(_array).forEach((_posicion) => {
      if (Utils.existeValor(_array[_posicion][_encuesta]) === 1) {
        if (
          _array[_posicion][_encuesta] !== 0 &&
          _array[_posicion][_encuesta] !== "0"
        ) {
          _value += 1
        }
      }
    })
    /** Se saca la diferencia y se redondea a la unidad */
    _value = Number(_value.toFixed(0))
    return _value
  }

  static faltantesIntermedio = function (_array, _encuesta) {
    var _value
    /** Se saca la diferencia y se redondea a la unidad */
    _value = Number(
      (
        Object.keys(_array).length -
        Utils.existentesIntermedio(_array, _encuesta)
      ).toFixed(0)
    )
    return _value
  }

  static conformesSimple = function (_value) {
    var _limite = 6
    if (Utils.existeValor(_value)) {
      if (_value < _limite) {
        return 0
      } else {
        return 1
      }
    } else {
      return undefined
    }
  }

  static porcentajeIntermedio = function (_array, _encuesta) {
    var _value = 0
    _value =
      (100 * Utils.existentesIntermedio(_array, _encuesta)) /
      Object.keys(_array).length
    /** Se redondea a una décima */
    _value = Number(_value.toFixed(1))
    _value = _value + "%"
    return _value
  }

  /**
   * Calcula NPS o ISN dado un arreglo distribucion de objetos {x:"1", Freq:4}
   * @param {Array} distribucion
   * @param {Integer} maxDetractores
   * @param {Integer} minPromotores
   * @returns
   */
  static calculaNpsIsn(distribucion, maxDetractores, minPromotores) {
    /** Evitamos intentar cálculos cuando no tenemos los datos adecuados */
    if (
      !Array.isArray(distribucion) ||
      maxDetractores < 1 ||
      minPromotores > 10 ||
      maxDetractores > minPromotores
    ) {
      log.debug(distribucion)
      log.debug(maxDetractores)
      log.debug(minPromotores)
      log.error("Parámetros inválidos para calcular NPS-ISN")
      return {
        valor: NaN,
        detractores: NaN,
        promotores: NaN,
        neutros: NaN,
      }
    }
    /** Datos básicos para el cálculo */
    let _detractores = 0
    let _promotores = 0
    let _total = 0
    /** Revisamos cada dato en la distribución */
    distribucion.forEach((dato) => {
      /** Actualizamos detractores o promotores de acuerdo a los bordes */
      if (parseInt(dato.x) <= maxDetractores) {
        _detractores += dato.Freq
      } else if (parseInt(dato.x) <= minPromotores) {
        _promotores += dato.Freq
      }
      /** Siempre sumamos la frecuencia al total */
      _total += dato.Freq
    })
    /** Detractores menos promotores como porcentaje del total, va de -100 a 100 */
    let _valor =
      _total > 0 ? (100 * (_promotores - _detractores)) / _total : NaN
    /** Retornamos objeto con los valores necesarios */
    return {
      valor: _valor,
      detractores: _detractores,
      promotores: _promotores,
      neutros: _total - _promotores - _detractores,
    }
  }
}

export default Utils
